(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SedutaDeleteController',SedutaDeleteController);

    SedutaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Seduta', 'toastr'];

    function SedutaDeleteController($uibModalInstance, entity, Seduta, toastr) {
        var vm = this;

        vm.seduta = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Seduta.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
